import React from "react";

const MainGeoLoader = () => {
    return (
        <div className="main_geo_loader">
            <div className="main_geo_loader_header">
                <div className="main_geo_loader_header_row">
                    <div className="main_geo_loader_header_row_btn_cont">
                    <div className="main_geo_loader_header_row_btn"></div>
                    <div className="main_geo_loader_header_row_btn"></div>
                    <div className="main_geo_loader_header_row_btn"></div>
                    </div>
                </div>
                <div className="main_geo_loader_header_row">
                    <div className="main_geo_loader_header_inner"></div>
                    <div className="main_geo_loader_header_inner"></div>
                </div>

            </div>
            <div className="main_geo_loader_charts_cont">
                <div className="main_geo_loader_charts_cont_inner"></div>
                {/* <div className="main_geo_loader_charts_cont_inner"></div> */}

            </div>
            <div className="main_geo_loader_table_cont">
                <div className="main_geo_loader_table_cont_inner">
                    <div className="main_geo_loader_table_row main_geo_loader_table_header">
                        <div className="main_geo_loader_table_cell w-20"></div>
                        <div className="main_geo_loader_table_cell w-30"></div>
                        <div className="main_geo_loader_table_cell w-20"></div>
                        <div className="main_geo_loader_table_cell w-15"></div>
                        <div className="main_geo_loader_table_cell w-15"></div>
                    </div>

                    {Array.from({ length: 3 }).map((_, rowIndex) => (
                        <div
                            className="main_geo_loader_table_row"
                            key={rowIndex}
                        >
                            <div className="main_geo_loader_table_cell w-20"></div>
                            <div className="main_geo_loader_table_cell w-30"></div>
                            <div className="main_geo_loader_table_cell w-20"></div>
                            <div className="main_geo_loader_table_cell w-15"></div>
                            <div className="main_geo_loader_table_cell w-15"></div>
                        </div>
                    ))}
                </div>
            </div>

        </div>
    )
}

export default MainGeoLoader